module.exports = __webpack_public_path__ + "static/media/Instagram.376386f5.svg";